import React, { useEffect } from 'react'
import TableFixedPage from '../TableFixedPage/TableFixedPage'
import { getAcountingApi } from '../../Api/PanelAdminServices'
import { errorToast } from '../../Utils/Toast/Toast'
import { useState } from 'react'
import InComeTable from '../Tables/InComeTable/InComeTable'
import { JalaliDate } from '../../Utils/JalaliDate/JalaliDate'

const OutComeContainer = () => {
    const[inCome,setinCome]=useState([])

    useEffect(()=>{
        getAcountingData()
    },[])
    const getAcountingData=()=>{
        getAcountingApi((succ,res)=>{
            if(succ){
                if(res.status===0){
                    errorToast("مشکلی پیش آمده است")
                }else{
                    setinCome(res.income)
                }
            }else{
                errorToast("خطایی در سرور رخ داده است")
            }
        })
    }
 //////////////// data table ///////////////
    const data =inCome&&inCome.map((item) => {
        return {
            key: item.id,
            trackId:item.id,
            idpayAmount:item.idpay_amount,
            idpayCardNo:item.idpay_card_no,
            date:item.date,
            idpayHashedCardNo:item.idpay_hashed_card_no,
            idpayId:item.idpay_id,
            idpayPaymentAmount:item.idpay_payment_amount,
            idpayPaymentDate:item.idpay_payment_date,
            idpayPaymentTrackId:item.idpay_payment_track_id,
            idpayStatus:item.idpay_status,
            idpayTrackId:item.idpay_track_id,
            idpayVerifyDate:item.idpay_verify_date,
            orderId:item.order_id
        };
    });
  return (
    <div>
        <TableFixedPage title={"حسابداری"} />
        <InComeTable data={data}/>
    </div>
  )
}


export default OutComeContainer